export const getInsightText = (zomato, swiggy, metricType) => {
    if (zomato === swiggy) {
      return "Both platforms performed at a similar level.";
    }
  
    const leader = zomato > swiggy ? "Zomato" : "Swiggy";
  
    // safe percentage (always positive)
    const base = Math.min(zomato, swiggy) || 1;
    const percent = (
      ((Math.max(zomato, swiggy) - base) / base) *
      100
    ).toFixed(1);
  
    switch (metricType) {
  
      // -----------------------
      // VOLUME METRICS
      // -----------------------
  
      case "orders":
        return `${leader} is driving ${percent}% more orders, positioning it as the stronger volume engine.`;
  
      case "gmv":
        return `${leader} is generating ${percent}% higher revenue, reflecting stronger demand momentum.`;
  
      case "menuOpen":
        return `${leader} attracts ${percent}% more customer traffic, giving it stronger visibility and discovery advantage.`;
  
      case "cartbuild":
        return `${leader} shows ${percent}% higher cart activity, indicating stronger mid-funnel engagement.`;
  
      case "orderMake":
        return `${leader} converts ${percent}% more final purchases, demonstrating superior checkout conversion.`;
  
      // -----------------------
      // ADS PERFORMANCE
      // -----------------------
  
      case "adsMenuOpens":
        return `${leader} drives ${percent}% more ad-driven traffic, reflecting stronger campaign exposure.`;
  
      case "adsOrders":
        return `${leader} generates ${percent}% more ad-attributed orders, indicating better paid performance efficiency.`;
  
      case "adsSales":
        return `${leader} produces ${percent}% higher ad-generated revenue, showcasing stronger campaign monetization.`;
  
      case "adsSpend":
        return `Ad investment is ${percent}% higher on ${leader}, indicating stronger growth emphasis on that platform.`;
  
      case "roi":
        return `${leader} delivers ${percent}% stronger ROI, making it the more efficient advertising channel.`;
  
      // -----------------------
      // DISCOUNT & BURN
      // -----------------------
  
      case "discount":
        return `${leader} is offering ${percent}% higher discounts, which may accelerate growth but increase margin pressure.`;
  
      case "burn":
        return `${leader} operates with a ${percent}% higher burn rate, suggesting heavier reliance on discounts and paid marketing to drive growth.`;
  
      case "adsDiscountBurn":
        return `${leader} has a ${percent}% higher combined ads and discount burn, impacting overall profitability.`;
  
      default:
        return "";
    }
  };